import { Environment, Network, RecordSource, Store } from "relay-runtime";
import getCookie from "./utils/getCookie";

const fetchQuery = (operation, variables) => {
  return fetch("/api/v1/graphql/", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      "X-CSRFToken": getCookie("csrftoken")
    },
    body: JSON.stringify({
      query: operation.text,
      variables
    })
  })
    .then(response => {
      return response.json();
    })
    .then(json => {
      // The `errors` array is not passed along to <QueryRenderer />'s `render()` method if the `data`
      // object received from the endpoint is not `null`. This seems to be a bug and to work around
      // it, an error is thrown which does get passed along to `render()`.
      // We only want to do this for query operations as mutations work fine.
      if (Array.isArray(json.errors) && operation.operationKind === "query") {
        throw new Error(JSON.stringify(json.errors));
      }
      return json;
    });
};

const environment = new Environment({
  network: Network.create(fetchQuery),
  store: new Store(new RecordSource())
});

export default environment;
